var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.16763 19.3844C7.99346 19.3844 7.8193 19.3202 7.6818 19.1827C7.41596 18.9169 7.41596 18.4769 7.6818 18.2111L13.6585 12.2344C14.0985 11.7944 14.0985 11.0794 13.6585 10.6394L7.6818 4.66274C7.41596 4.39691 7.41596 3.95691 7.6818 3.69107C7.94763 3.42524 8.38763 3.42524 8.65346 3.69107L14.6301 9.66774C15.0976 10.1352 15.3635 10.7677 15.3635 11.4369C15.3635 12.1061 15.1068 12.7386 14.6301 13.2061L8.65346 19.1827C8.51596 19.3111 8.3418 19.3844 8.16763 19.3844Z",
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightt);
export default __webpack_public_path__ + "static/media/rightt.50ac1d8707dcf16b86c95b1a71be68cf.svg";
export { ForwardRef as ReactComponent };